export default __webpack_public_path__ + "static/media/register-background.6ea076de.jpg";